import { FormattedMessage } from '@futrli/localisation';
import React, { FC } from 'react';

import { getMessageEntryFormat, NumberExplainedMessagesIds } from './number-explained-messages';

import styles from './number-explained.scss';

interface Props {
  messageId: NumberExplainedMessagesIds;
}

export const NumberExplainedByMessageId: FC<Props> = ({ messageId }) => {
  const [id, message] = getMessageEntryFormat(messageId);

  return (
    <div className={styles.content}>
      {/* eslint-disable-next-line formatjs/enforce-default-message */}
      <FormattedMessage id={id} defaultMessage={message} />
    </div>
  );
};
